/* eslint-disable no-empty */
/* eslint-disable no-undef */

import { initTagManager } from '../../routers/AppRouter';

async function contentView(url) {
  try {
    initTagManager({
      event: 'conteudo-visualizado',
      url,
    });
  } catch (e) { }
}

async function search(term) {
  try {
    initTagManager({
      event: 'pesquisa',
      termo: term,
    });
  } catch (e) { }
}

async function addProductToCart(product = {}) {
  try {
    initTagManager({
      event: 'adicao-carrinho',
      produto: {
        titulo: product.name,
        valor: `${product.price}`,
        quantidade: `${product.quantity}`,
      },
    });
  } catch (e) { }
}

async function newUserRegister() {
  try {
    initTagManager({ event: 'cadastro' });
  } catch (e) { }
}

async function onInitCheckout(products = []) {
  try {
    let total = 0;
    products = products.map((it) => {
      total += it.product.price ? (it.product.price.value || 0) : 0;
      return ({
        titulo: it.product.name,
        valor: `${it.product.price ? (it.product.price.value || 0) : 0}`,
        quantidade: `${it.product.quantity}`,
      });
    });

    if (products.length) {
      initTagManager({
        event: 'inicio-compra',
        produtos: products,
        total: `${total}`,
      });
    }
  } catch (e) { }
}

async function onEndCheckout(products = []) {
  try {
    let total = 0;
    products = products.map((it) => {
      total += it.product.price ? (it.product.price.value || 0) : 0;
      return ({
        titulo: it.product.name,
        valor: `${it.product.price ? (it.product.price.value || 0) : 0}`,
        quantidade: `${it.product.quantity}`,
      });
    });

    if (products.length) {
      initTagManager({
        event: 'compra',
        produtos: products,
        total: `${total}`,
      });
    }
  } catch (e) { }
}

async function ecommerceImpressions(products = []) {
  try {
    products = products.map(it => ({
      name: it.name,
      id: it.id,
      price: it.price,
      brand: it.brand,
      category: it.category,
      list: it.list,
      position: it.position,
    }));

    if (products.length) {
      initTagManager({
        ecommerce: {
          currencyCode: 'BRL',
          impressions: products,
        },
      });
    }
  } catch (e) { }
}

async function ecommerceClick(products = []) {
  try {
    let productList = '';
    products = products.map((it) => {
      productList = it.list;

      return {
        name: it.name,
        id: it.id,
        price: it.price,
        brand: it.brand,
        category: it.category,
        position: it.position,
      };
    });

    if (products.length) {
      initTagManager({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list: productList },
            products,
          },
        },
        eventCallback: () => { },
      });
    }
  } catch (e) { }
}

async function ecommerceDetail(products = []) {
  try {
    products = products.map(it => ({
      name: it.name,
      id: it.id,
      price: it.price,
      brand: it.brand,
      category: it.category,
    }));

    if (products.length) {
      initTagManager({
        ecommerce: {
          detail: {
            products,
          },
        },
      });
    }
  } catch (e) { }
}

async function ecommerceAddProductToCart(products = []) {
  try {
    products = products.map(it => ({
      name: it.name,
      id: it.id,
      price: it.price,
      brand: it.brand,
      category: it.category,
      quantity: it.quantity,
    }));

    if (products.length) {
      initTagManager({
        event: 'addToCart',
        ecommerce: {
          currencyCode: 'BRL',
          add: {
            products,
          },
        },
      });
    }
  } catch (e) { }
}

async function ecommerceRemoveProductToCart(products = []) {
  try {
    products = products.map(it => ({
      name: it.name,
      id: it.id,
      price: it.price,
      brand: it.brand,
      category: it.category,
      quantity: it.quantity,
    }));

    if (products.length) {
      initTagManager({
        event: 'removeFromCart',
        ecommerce: {
          remove: {
            products,
          },
        },
      });
    }
  } catch (e) { }
}

async function ecommercePromotions(products = []) {
  try {
    products = products.map(it => ({
      id: it.id,
      name: it.name,
      creative: it.creative || '',
      position: it.position,
    }));

    if (products.length) {
      initTagManager({
        ecommerce: {
          promoView: {
            promotions: products,
          },
        },
      });
    }
  } catch (e) { }
}

async function ecommercePromotionClick(products = []) {
  try {
    products = products.map(it => ({
      id: it.id,
      name: it.name,
      creative: it.creative || '',
      position: it.position,
    }));

    if (products.length) {
      initTagManager({
        event: 'promotionClick',
        ecommerce: {
          promoClick: {
            promotions: products,
          },
        },
        eventCallback: () => { },
      });
    }
  } catch (e) { }
}

async function ecommerceCheckoutSteps(cartItems = [], step = 1, option = '') {
  try {
    const products = cartItems.map(it => ({
      name: it.name,
      id: it.code,
      price: `${it.price ? (it.price.value || 0) : 0}`,
      brand: it.brand ? it.brand.description : '',
      category: it.category ? it.category.name : '',
      quantity: it.quantity || 0,
    }));

    if (products.length) {
      initTagManager({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: { step, option },
            products,
          },
        },
        eventCallback: () => { },
      });
    }
  } catch (e) { }
}

async function ecommercePurchase(cartItems = [], actionField) {
  try {
    let products = [];

    try {
      products = cartItems.map(it => ({
        name: it.name,
        id: it.code,
        price: `${it.price ? (it.price.value || 0) : 0}`,
        brand: it.brand ? it.brand.description : '',
        category: it.category ? it.category.name : '',
        quantity: it.quantity || 0,
      }));
    } catch (e) { }

    initTagManager({
      ecommerce: {
        purchase: {
          actionField,
          products,
        },
      },
    });
  } catch (e) { }
}

export default {
  contentView,
  search,
  addProductToCart,
  newUserRegister,
  onInitCheckout,
  onEndCheckout,
  ecommerceImpressions,
  ecommerceClick,
  ecommerceDetail,
  ecommerceAddProductToCart,
  ecommerceRemoveProductToCart,
  ecommercePromotions,
  ecommercePromotionClick,
  ecommerceCheckoutSteps,
  ecommercePurchase,
};
